module.exports = __webpack_public_path__ + "img/348.8233a4c6.png";